<template>
    <div>
        <Modal v-model="show"
            :width="1300"
            :footer-hide="true"
            title="产品审核详情"
            @on-visible-change="onShowChange">
            <Card :padding="0"
                :bordered="false"
                :dis-hover="true">
                <Spin v-if="innerSpin"
                    size="large"
                    fix></Spin>
                <Row :gutter="16">
                    <Col span="24">
                    <Form label-position="top"
                        class="small-form">
                        <Row :gutter="16">
                            <Col span="4">
                            <FormItem label="种苗场">
                                <Input :value="approveRecord.seedFarmName"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="4">
                            <FormItem label="申请人">
                                <Input :value="approveRecord.userPersonName"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="4">
                            <FormItem label="申请时间">
                                <Input :value="formatDateTimeString(approveRecord.productApproveRecordCreateAt)"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="4">
                            <FormItem label="申请数量">
                                <Input :value="approveRecord.productApproveRecordAmount"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="4">
                            <FormItem label="审批状态">
                                <Input :value="approveRecord.productApproveRecordProgress"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                        </Row>
                    </Form>
                    </Col>
                </Row>

                <Row :gutter="16">
                    <Col span="24">
                    <Table ref="mainTable"
                        size="small"
                        :columns="mainTable.tableColumns"
                        :data="approveProductList"
                        border
                        stripe />
                    </Col>
                </Row>

                <Row :gutter="16"
                    type="flex"
                    justify="end"
                    style="margin-top: 10px;">
                    <Col span="2">
                    <Button v-if="canUpdateApproveResult"
                        type="primary"
                        size="default"
                        @click="onSave">审批更新</Button>
                    </Col>
                </Row>
            </Card>
            <ProductPopupEdit v-model="productPopup.popupEditModalShow"
                :popup-edit-resource="productPopup.popupEditResource"
                :product-uuid="productPopup.popupEditProductUuid"
                readonly />
        </Modal>
    </div>
</template>

<script>
import { formatDateTimeString } from '@/libs/logic';
import search from '@/libs/search';
import { singleImageRender } from '@/libs/tableRowImageRender';
import ProductPopupEdit from '@/view/product-management/product-management/product-popup-edit';
import {
    PRODUCT_APPROVAL_INREVIEW,
    PRODUCT_APPROVAL_NO,
    PRODUCT_APPROVAL_YES,
    productApprovalFormat
} from '@/view/product-management/product-management/ProductApproveDefine';
import { APPROVE_RECORD_PROGRESS_INREVIEW } from '@/view/product-management/productApprove-management/ApproveRecordProgressTypeDefine';

import {
    getProductApproveDetail,
    updateProductApproveResult
} from '@/api/modules/product-management/productApprove-management';

import { pageInit4ProductEdit } from '@/api/modules/product-management/product-management';
import { getResource, setResource } from '@/view/product-management/product-management/ProductPopupHelper';

export default {
    name: 'ProductApproveDetail',
    components: {
        ProductPopupEdit
    },
    data() {
        return {
            show: false,
            innerSpin: false,
            orderUuid: '',
            approveRecord: {
                seedFarmName: '',
                userPersonName: '',
                productApproveRecordUuid: '',
                productApproveRecordCreateAt: '',
                productApproveRecordAmount: 0,
                productApproveRecordProgress: ''
            },
            approveProductList: [],
            mainTable: {
                tableColumns: [
                    { title: '大类', key: 'mainCategoryName', width: 80, align: 'center' },
                    { title: '小类', key: 'subCategoryName', width: 80, align: 'center' },
                    { title: '编码', key: 'productCode', width: 80, align: 'center' },
                    { title: '名称', key: 'productName', width: 100, align: 'center' },
                    { title: '标准卡', key: 'standardCardName', width: 140, align: 'center' },
                    { title: '销售期限', key: 'productSalesPeriod', width: 80, align: 'center' },
                    { title: '成品图', width: 80, align: 'center', render: (h, params) => singleImageRender(h, params.row.productFinishImageFile) },
                    { title: '申请说明', key: 'productApproveDetailRequestRemark', align: 'center' },
                    {
                        title: '审批说明',
                        align: 'left',
                        width: 200,
                        render: (h, params) => {
                            if (params.row.productApproveDetailResult === PRODUCT_APPROVAL_INREVIEW) {
                                return h('Input', {
                                    props: {
                                        value: params.row.productApproveDetailResponseRemark
                                    },
                                    on: {
                                        'on-change': event => {
                                            this.approveProductList[params.index].productApproveDetailResponseRemark = event.target.value;
                                        }
                                    }
                                });
                            }

                            return h('div', {}, params.row.productApproveDetailResponseRemark);
                        }
                    },
                    {
                        title: '审批',
                        key: 'action',
                        align: 'center',
                        width: 200,
                        render: (h, params) => {
                            if (this.canUpdateApproveResult) {
                                const radioGroup = [];
                                radioGroup.push(h('Radio', {
                                    props: {
                                        label: PRODUCT_APPROVAL_INREVIEW
                                    }
                                }, '审批中'));
                                radioGroup.push(h('Radio', {
                                    props: {
                                        label: PRODUCT_APPROVAL_YES
                                    }
                                }, '通过'));
                                radioGroup.push(h('Radio', {
                                    props: {
                                        label: PRODUCT_APPROVAL_NO
                                    }
                                }, '不通过'));

                                return h('div', [
                                    h('RadioGroup', {
                                        props: {
                                            value: params.row.productApproveDetailResult
                                        },
                                        on: {
                                            input: value => {
                                                this.approveProductList[params.index].productApproveDetailResult = value;
                                            }
                                        }
                                    }, radioGroup)
                                ]);
                            }

                            return h('span', {}, productApprovalFormat(params.row.productApproveDetailResult));
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    on: {
                                        click: () => {
                                            this.onProductView(params.row);
                                        }
                                    }
                                }, '查看')
                            ]);
                        }
                    }
                ],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: []
            },
            productPopup: {
                popupEditModalShow: false,
                popupEditResource: getResource(),
                popupEditProductUuid: ''
            }
        };
    },
    computed: {
        canUpdateApproveResult() {
            return this.approveRecord
                && this.approveRecord.productApproveRecordProgress === APPROVE_RECORD_PROGRESS_INREVIEW
                && this.$checkAccessArray(['A']);
        }
    },
    mounted() {
        // this.init();

        // pageInit4ProductEdit().then(res => {
        //     if (res.code === 0) {
        //         setResource(this.productPopup.popupEditResource, res);
        //     }
        // });
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();

                pageInit4ProductEdit().then(res => {
                    if (res.code === 0) {
                        setResource(this.productPopup.popupEditResource, res);
                    }
                });
            }
        },
        showModal(orderUuid) {
            this.orderUuid = orderUuid;
            this.show = true;
        },
        formatDateTimeString,
        init() {
            // const query = this.$route.query;
            if (!this.orderUuid) {
                this.$Modal.error({ title: '出错啦', content: '审核信息错误' });
                return;
            }

            this.innerSpin = true;
            getProductApproveDetail(this.orderUuid).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    const approveDetail = res.data.approveDetail;
                    this.approveRecord = Object.assign(this.approveRecord, approveDetail.approveRecord);
                    this.approveProductList = approveDetail.approveProductList;
                }
            }).catch(() => {
                this.innerSpin = false;
            });
        },
        onSave() {
            this.$Modal.confirm({
                title: '确认提交审批结果？',
                onOk: () => {
                    const results = this.approveProductList.map(p => {
                        return {
                            productApproveDetailUuid: p.productApproveDetailUuid,
                            productUuid: p.productApproveDetailRelateProductUuid,
                            productTag: `${p.productName}（${p.productCode}）`,
                            result: p.productApproveDetailResult,
                            productApproveDetailResponseRemark: p.productApproveDetailResponseRemark
                        };
                    });

                    const submitData = {
                        results: results
                    };

                    this.innerSpin = true;
                    updateProductApproveResult(submitData).then(res => {
                        this.innerSpin = false;
                        if (res.code === 0) {
                            this.show = false;
                            this.$parent.init();
                        }
                    });
                }
            });
        },
        onProductView(row) {
            this.productPopup.popupEditProductUuid = row.productApproveDetailRelateProductUuid;
            this.productPopup.popupEditModalShow = true;
        }
    }
};
</script>

<style scoped>
</style>
